/**
 * Uygulama içi baskı yardımcıları (ADR 0042 §20; ADR 0028 #30, #34(3)): revizyonun onaylı baskı
 * PDF'i önizleyicide açık olmasa da M8a3 altlığıyla basılır. Office gerekmez (ADR 0024 #20).
 * Bu modül yalnız tarayıcıda çalışır.
 */

/** PDF'i (adresinden, `Range` ile) sayfa resimlerine çevirir ve altlıkla basar. */
export async function printPdfUrl(
  url: string,
  footer: string,
  print: () => Promise<void>,
): Promise<void> {
  const { openPdf, pdfPageImage, mountPrintRoot } = await import('../documents/viewer-engines.js');
  const handle = await openPdf(url);
  const urls: string[] = [];
  const holder = globalThis.document.createElement('div');
  try {
    for (let page = 1; page <= handle.numPages; page += 1) {
      const src = await pdfPageImage(handle, page);
      urls.push(src);
      const wrap = globalThis.document.createElement('div');
      wrap.className = 'print-page';
      wrap.setAttribute('data-print-part', '');
      const image = globalThis.document.createElement('img');
      image.src = src;
      image.alt = '';
      wrap.append(image);
      holder.append(wrap);
      await image.decode().catch(() => undefined);
    }
    const cleanup = mountPrintRoot(
      globalThis.document,
      (root) => {
        while (holder.firstChild) root.append(holder.firstChild);
      },
      footer,
      { cleanupUrls: urls },
    );
    try {
      await print();
    } finally {
      cleanup();
    }
  } finally {
    handle.destroy();
  }
}
